import React, { useState, useEffect } from 'react';
import { Modal, Box, CircularProgress } from '@mui/material';
import { getSchemaForPlace } from './api.js';

const SchemaModal = ({ open, onClose, place_id, token, notificationState }) => {
  const [schemaPath, setSchemaPath] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSchema = async () => {
      setLoading(true);
      try {
        const data = await getSchemaForPlace(place_id, token, notificationState);
        setSchemaPath(data); // Устанавливаем полученный путь к изображению в состояние
      } catch (error) {
        console.error('Failed to fetch schema:', error);
      } finally {
        setLoading(false); // После получения ответа с сервера сбрасываем флаг загрузки
      }
    };

    if (open) {
      fetchSchema(); // Вызываем функцию загрузки схемы при открытии модального окна
    }
  }, [open, place_id, token, notificationState]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          maxHeight: 'calc(100svh)',
          minHeight: 'calc(100svh - 350px)',
        }}
      >
        {loading ? (
          <CircularProgress /> // Отображаем лоадер во время загрузки
        ) : (
          <img
            src={schemaPath}
            alt='Схема зала'
            style={{
              maxWidth: '90%',
              maxHeight: '800px',
            }}
          />
        )}
      </Box>
    </Modal>
  );
};

export default SchemaModal;
